import React, { useEffect, useState } from 'react'
import CardCustom from '../../custom/card-custom'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import NavTitle from '../../nav-title'
import imgUser from '../../../images/user.png'
import {
  getRightOrgDetailAPI,
  putRightOrgDetailAPI
} from '../../../services/right-org'
import { Link, useSearchParams } from 'react-router-dom'
import Error_500 from '../../error/error-500'
import { TXTSUCCESS } from '../../../Constants'
import SwalCustom from '../../../alert/swal-custom'
import Error_false from '../../error/error-false'
import TextNavTitle from '../../TextNavTitle'
import { FaAnglesRight } from 'react-icons/fa6'

function AssetOrgDetail() {
  const [dataOrg, setDataOrg] = useState([])
  const [checkActive, setCheckActive] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [detail, setDetail] = useState(null)
  const [detailRight, setDetailRight] = useState([])
  let [searchParams] = useSearchParams()
  const orgId = searchParams.get('org')
  const username = searchParams.get('username')
  useEffect(() => {
    getRightOrgDetail()
  }, [])

  useEffect(() => {
    setDataOrg(detailRight)
  }, [detailRight])

  const getRightOrgDetail = async () => {
    const body = { orgId, username }
    const res = await getRightOrgDetailAPI(body)
    if (!res) return
    if (res.status) {
      setDetail(res?.result)
      setDetailRight(res?.result?.right)
    }
  }

  const handleEdit = () => {
    setCheckActive(!checkActive)
  }

  const handleOrgChange = (id, toDoList) => {
    setDetailRight((prev) => {
      return prev.map((d) =>
        d.right_org_id === id
          ? {
              ...d,
              ...toDoList,
              right_detail: d.right_detail.map((t) => ({
                ...t,
                status_checked:
                  toDoList.right_checked && t.status_id === 1 ? 1 : 0
              }))
            }
          : d
      )
    })
    setDataOrg(detailRight)
  }

  const handleSubStatus = (index, i) => {
    const subData = [...detailRight]
    const resetData = subData[i].right_detail.map((d) => ({
      ...d,
      status_checked: 0
    }))

    resetData[index] = {
      ...subData[i].right_detail[index],
      status_checked: 1
    }

    subData[i].right_detail = [...resetData]
    setDataOrg(subData)
  }

  const onSubmit = async () => {
    try {
      setIsSave(true)
      const body = {
        orgId,
        username: detail.username ?? '',
        statusList: dataOrg.map((d, i) => {
          let statusId = d.right_detail.find((item) => item.status_checked)
          return {
            id: d.right_id,
            statusOrgId: d.right_org_id,
            statusId: statusId?.status_id === 1 ? 1 : 2, //status E and R
            statusActive: d.right_checked ? 1 : 0 //select org
          }
        })
      }
      const resp = await putRightOrgDetailAPI(body)
      setIsSave(false)
      setCheckActive(false)
      getRightOrgDetail()
      if (resp && resp.status) {
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <>
      <NavTitle>
        <TextNavTitle>
          <Link
            to={-1}
            className={`my-auto text-reset text-decoration-none pointer-event`}
          >
            Organization Right <FaAnglesRight />
            <label className="small fw-medium ms-2">Detail</label>
          </Link>
        </TextNavTitle>
      </NavTitle>
      <CardCustom>
        <div className="p-3">
          {isSave && <div className="preloader"></div>}

          <Row>
            <Col xl={1}>
              <div className="d-flex align-items-middle justify-content-start mt-2 m-4 mb-0 me-0">
                <Image
                  src={detail?.img_url ?? imgUser}
                  style={{ width: '70px', borderRadius: '50%' }}
                />
              </div>
            </Col>
            <Col xl={4}>
              <div className="mt-3 m-5 mb-0 me-0">
                <div className="d-flex justify-content-start small">
                  {detail ? (
                    <p>
                      {detail?.title_en ?? '-'} {detail?.name_en ?? '-'}{' '}
                      {detail?.surname_en ?? '-'} ({detail?.nickname_en ?? ''})
                    </p>
                  ) : (
                    <p className="placeholder col-12"></p>
                  )}
                </div>
                {detail ? (
                  <div className="small">{detail?.code ?? '-'}</div>
                ) : (
                  <div className="small placeholder col-12"></div>
                )}
              </div>
            </Col>
            <Col xl={3}>
              <div className="mt-3 ">
                <div className="d-flex align-items-middle justify-content-start small">
                  {detail ? (
                    <p>Department: {detail?.division_en ?? '-'}</p>
                  ) : (
                    <p className="placeholder col-12"></p>
                  )}
                </div>
                {detail ? (
                  <div className="small">
                    Position: {detail?.position_en ?? '-'}
                  </div>
                ) : (
                  <div className="small placeholder col-12"></div>
                )}
              </div>
            </Col>
            <Col xl={3}>
              <div className="mt-3">
                <div className="d-flex justify-content-start small">
                  {detail ? (
                    <p>Type: {detail?.type ?? '-'}</p>
                  ) : (
                    <p className="placeholder col-12"></p>
                  )}
                </div>

                {detail ? (
                  <div className="small">Email: {detail?.email ?? '-'}</div>
                ) : (
                  <div className="small placeholder col-12"></div>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <div className="p-3">
          <Table bordered className="mb-3">
            <thead
              className=" text-white bg-hrms"
              style={{ position: 'sticky', top: '0px', zIndex: 999 }}
            >
              <tr className=" font-title-table">
                <th
                  className="fw-normal "
                  style={{
                    whiteSpace: 'nowrap',
                    width: '50px'
                  }}
                >
                  #
                </th>
                <th
                  style={{
                    whiteSpace: 'nowrap'
                  }}
                  className="fw-normal"
                >
                  Organization Right
                </th>
                <th
                  className="fw-normal text-center"
                  style={{ whiteSpace: 'nowrap', width: '100px' }}
                >
                  Enable
                </th>
                <th
                  className="fw-normal text-center"
                  style={{ whiteSpace: 'nowrap', width: '100px' }}
                >
                  Read Only
                </th>
              </tr>
            </thead>
            <tbody className="text-break fw-light">
              {detailRight.map((d, i) => (
                <tr className="mb-3 align-middle" key={i}>
                  <td className="small">{i + 1}</td>
                  <td>
                    {checkActive ? (
                      <div
                        className="pointer-event"
                        onClick={() => {
                          handleOrgChange(d?.right_org_id, {
                            right_checked: !d?.right_checked // Toggle the checkbox status
                          })
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          className="fs-6 "
                          label={d?.right_org}
                          checked={d?.right_checked}
                        />
                        {/* {d?.right_org} */}
                      </div>
                    ) : (
                      <>
                        <Form.Check
                          label={d?.right_org}
                          className="fs-6"
                          type="checkbox"
                          checked={d?.right_checked}
                          disabled
                        />
                        {/* {d?.right_org} */}
                      </>
                    )}
                  </td>

                  {d?.right_detail.map((s, index) => (
                    <td>
                      <div
                        className="text-center m-3 mt-0 mb-0 "
                        key={`${i}-${index}`}
                      >
                        {checkActive ? (
                          <>
                            <Form.Check
                              // label={s?.status_name}
                              type="checkbox"
                              className="fs-5 "
                              disabled={!d?.right_checked}
                              checked={s?.status_checked}
                              onChange={() => {
                                handleSubStatus(index, i)
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <Form.Check
                              // label={s?.status_name}
                              className="fs-5"
                              type="checkbox"
                              checked={s.status_checked}
                              disabled={!checkActive}
                            />
                          </>
                        )}
                      </div>
                    </td>
                  ))}

                  {/* <td></td> */}
                </tr>
              ))}
            </tbody>
          </Table>
          <Row>
            <div className="col-12">
              <div className="d-flex justify-content-center gap-2 ">
                {!checkActive ? (
                  <>
                    <Button
                      className="border-0"
                      style={{ minWidth: 200, backgroundColor: '#1A2B45' }}
                      onClick={() => handleEdit()}
                    >
                      Edit
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      className="border-0"
                      style={{ minWidth: 200 }}
                      variant="secondary"
                      onClick={() => handleEdit()}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="border-0 "
                      style={{ minWidth: 200 }}
                      onClick={onSubmit}
                    >
                      Submit
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Row>
        </div>
      </CardCustom>{' '}
    </>
  )
}

export default AssetOrgDetail
